module.exports = __webpack_public_path__ + "images/icon-fps_qr.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-fps_qr.png
// module id = TDqX
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13